import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TimelineHttpResponse } from '../models/timeline.model';
export abstract class TimelineApi {
  constructor(protected readonly http: HttpClient) {}

  abstract getTimelineFeed(pageNumber: number, limit: number): Observable<TimelineHttpResponse>;
}
